var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-scroller"},[_c('navbar'),_c('div',{staticClass:"container-fluid page-body-wrapper"},[_c('sidebar'),_c('div',{staticClass:"main-panel"},[_c('div',{staticClass:"content-wrapper content-wrapper-page p-3"},[_c('router-view')],1),_c('footerbar')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }